import React from 'react';
import { View } from 'react-native';

import styles from './feedback.style';
import { useFont } from '../../../hooks/lesson-player.context';
import { ThemedText } from '../../themed-text';

export function Feedback({ title = '', message = '' }) {
  const font = useFont();

  if (!title && !message) {
    return null;
  }

  return (
    <View style={styles.container}>
      {!!title && (
        <ThemedText type="success" fontSize="small" style={font.primary.bold}>
          {title}
        </ThemedText>
      )}

      {!!message && (
        <ThemedText type="gray" fontSize="extraSmall">
          {message}
        </ThemedText>
      )}
    </View>
  );
}
